<template>
  <div :class="$style.hours">
    <h2 v-if="props.heading" :class="$style.title">
      {{ props.heading }}
    </h2>
    <p :class="$style.msg" v-html="msg"></p>
  </div>
</template>

<script setup lang="ts">
import { AppConfig } from '@/types/global.interface';
import { inject, onMounted, ref } from 'vue';

const appConfig = inject<AppConfig>('appConfig');

const msg = ref<string>('');

const props = withDefaults(
  defineProps<{
    heading?: string;
  }>(),
  {
    heading: 'Hours',
  }
);

onMounted(() => {
  let museumState;
  let storeState;
  const hours = appConfig.hours;

  // Shop online only state may have already been set.
  storeState = hours.store ? `The store is open from ${hours.store}.` : 'The store is closed.';

  // Museum is either open or closed
  museumState = hours.museum
    ? `The museum is open today from ${hours.museum}.`
    : 'The museum is closed today.';

  msg.value = hours.override_message
    ? hours.override_message
    : !hours.museum && !hours.store
      ? 'The museum and store are closed today.'
      : `${museumState} ${storeState}`;
});
</script>

<style lang="scss" module>
.hours {
  .msg {
    @include space-24-32-above;
  }
  .title {
    margin-top: 0;
  }
}
</style>
